import {
  PurchaseOrdersListingGetters,
  PurchaseOrdersListingActions,
  PurchaseOrdersListingMutations
} from '@/app/features/purchase-orders/features/purchase-orders-listing/purchase-orders-listing.keys';
import { purchaseOrdersListingService as pos } from '@/app/features/purchase-orders/features/purchase-orders-listing/purchase-orders-listing.service';

export const getInitialState = () => {
  return {
    purchaseOrdersLoading: true,
    purchaseOrders: [],
    purchaseOrdersFilteredRecordCount: 0,
    searchParam: null,
    purchaseOrdersFilters: {
      purchaseOrdersStatusFilterPreference: '',
      purchaseOrdersTypeFilterPreference: ''
    },
    purchaseOrdersSortOrder: {
      sortBy: 'client_name',
      sortDirection: 'desc'
    },
    purchaseOrdersPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    }
  };
};

export const purchaseOrdersListingStore = {
  state: getInitialState(),
  getters: {
    [PurchaseOrdersListingGetters.PurchaseOrders]: state => state.purchaseOrders,
    [PurchaseOrdersListingGetters.PurchaseOrdersCount]: state =>
      state.purchaseOrdersFilteredRecordCount,
    [PurchaseOrdersListingGetters.PurchaseOrdersSortOrder]: state => state.purchaseOrdersSortOrder,
    [PurchaseOrdersListingGetters.PurchaseOrdersSortBy]: state =>
      state.purchaseOrdersSortOrder.sortBy,
    [PurchaseOrdersListingGetters.PurchaseOrdersSortDirection]: state =>
      state.purchaseOrdersSortOrder.sortDirection,
    [PurchaseOrdersListingGetters.PurchaseOrdersPerPage]: state =>
      state.purchaseOrdersPaginationParameters.recordsPerPage,
    [PurchaseOrdersListingGetters.PurchaseOrdersListingOffset]: state =>
      state.purchaseOrdersPaginationParameters.offset,
    [PurchaseOrdersListingGetters.PurchaseOrderSearchParam]: state => state.searchParam,
    [PurchaseOrdersListingGetters.PurchaseOrdersLoading]: state => state.purchaseOrdersLoading
  },
  mutations: {
    [PurchaseOrdersListingMutations.SetPurchaseOrders]: (state, purchaseOrders) => {
      state.purchaseOrders = purchaseOrders;
    },
    [PurchaseOrdersListingMutations.SetPurchaseOrdersSortOrder]: (
      state,
      purchaseOrdersSortOrder
    ) => {
      state.purchaseOrdersSortOrder = purchaseOrdersSortOrder;
    },
    [PurchaseOrdersListingMutations.ResetPurchaseOrdersPaginationOffset]: state => {
      state.purchaseOrdersPaginationParameters.offset = 0;
    },
    [PurchaseOrdersListingMutations.SetPurchaseOrdersCount]: (state, count) => {
      state.purchaseOrdersFilteredRecordCount = count;
    },
    [PurchaseOrdersListingMutations.SetPurchaseOrdersPaginationParameters]: (
      state,
      paginationParameters
    ) => {
      state.purchaseOrdersPaginationParameters = paginationParameters;
    },
    [PurchaseOrdersListingMutations.SetPurchaseOrdersStatusFilterPreference]: (state, status) => {
      state.purchaseOrdersFilters.purchaseOrdersStatusFilterPreference = status;
    },
    [PurchaseOrdersListingMutations.SetPurchaseOrdersTypeFilterPreference]: (state, type) => {
      state.purchaseOrdersFilters.purchaseOrdersTypeFilterPreference = type;
    },
    [PurchaseOrdersListingMutations.SetPurchaseOrdersLoading](state, isLoading = true) {
      state.purchaseOrdersLoading = isLoading;
    },
    [PurchaseOrdersListingMutations.SetPurchaseOrdersSearchParam]: (state, searchParam) => {
      state.searchParam = searchParam;
    }
  },
  actions: {
    [PurchaseOrdersListingActions.SetPurchaseOrdersLoading]: function({ commit }, flag) {
      commit(PurchaseOrdersListingMutations.SetPurchaseOrdersLoading, flag);
    },
    [PurchaseOrdersListingActions.RetrievePurchaseOrders]: ({ state, commit }) => {
      return pos
        .retrievePurchaseOrders(
          state.purchaseOrdersFilters,
          state.purchaseOrdersSortOrder,
          state.purchaseOrdersPaginationParameters,
          state.searchParam
        )
        .then(result => {
          commit(PurchaseOrdersListingMutations.SetPurchaseOrders, result);
        });
    },
    [PurchaseOrdersListingActions.RetrievePurchaseOrdersCount]: ({ state, commit }) => {
      return pos
        .retrieveFilteredRecordCount(state.purchaseOrdersFilters, state.searchParam)
        .then(result => {
          commit(PurchaseOrdersListingMutations.SetPurchaseOrdersCount, result);
        });
    },
    [PurchaseOrdersListingActions.SetPurchaseOrdersSortOrder]: (
      { commit, dispatch },
      sortOrder
    ) => {
      commit(PurchaseOrdersListingMutations.SetPurchaseOrdersSortOrder, sortOrder);
      commit(PurchaseOrdersListingMutations.ResetPurchaseOrdersPaginationOffset);
      dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrders);
      dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrdersCount);
    },
    [PurchaseOrdersListingActions.UpdatePurchaseOrdersList](
      { commit, dispatch },
      purchaseOrdersList
    ) {
      commit(
        PurchaseOrdersListingMutations.SetPurchaseOrdersSearchParam,
        purchaseOrdersList.searchParam
      );
      if (purchaseOrdersList.searchParam) {
        commit(PurchaseOrdersListingMutations.ResetPurchaseOrdersPaginationOffset);
        commit(PurchaseOrdersListingMutations.SetPurchaseOrders, purchaseOrdersList.data);
        dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrdersCount);
      }
    },
    [PurchaseOrdersListingActions.SetPurchaseOrdersPaginationParameters]: (
      { commit, dispatch },
      paginationParameters
    ) => {
      commit(
        PurchaseOrdersListingMutations.SetPurchaseOrdersPaginationParameters,
        paginationParameters
      );
      dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrders);
      dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrdersCount);
    },
    [PurchaseOrdersListingActions.PurchaseOrdersFilterPreferenceUpdate]: (
      { commit, dispatch },
      selectedValue
    ) => {
      commit(PurchaseOrdersListingMutations.SetPurchaseOrdersStatusFilterPreference, selectedValue);
      dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrders);
      dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrdersCount);
    },
    [PurchaseOrdersListingActions.PurchaseOrdersTypeFilterPreferenceUpdate]: (
      { commit, dispatch },
      selectedValue
    ) => {
      commit(PurchaseOrdersListingMutations.SetPurchaseOrdersTypeFilterPreference, selectedValue);
      dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrders);
      dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrdersCount);
    }
  }
};
